import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, MatMenuModule, TranslateModule],
  exports: [MatMenuModule, TranslateModule],
})
export class SharedModule {}
